import type { ReactNode } from "react";
import { Divider, Grid, TextField, Typography } from "@mui/material";
import StatutButtonGroup from "components/atoms/buttons/StatutButtonGroup/StatutButtonGroup";
import { magasinierArticleStatutOptions } from "constants/SatutMap";
import Statut from "constants/Statut";
import type CommandeArticleFormModel from "models/CommandeArticleFormModel";
import ArticleHistoriqueStepper from "./ArticleHistoriqueStepper";

interface ArticleListProps {
  articlesList: Array<CommandeArticleFormModel>;
  setArticlesList: (c: Array<CommandeArticleFormModel>) => void;
}

function ArticleListStore({
  articlesList,
  setArticlesList,
}: Readonly<ArticleListProps>): ReactNode {
  function updateStatut(articleIndex: number, statutArticle: Statut): void {
    setArticlesList(
      articlesList.map((article, index) =>
        index === articleIndex ? { ...article, statutArticle } : article
      )
    );
  }

  function updateNumeroBonDeCommande(articleIndex: number, numeroBonDeCommande?: string): void {
    setArticlesList(
      articlesList.map((article, index) =>
        index === articleIndex ? { ...article, numeroBonDeCommande } : article
      )
    );
  }

  return (
    <Grid
      container
      size={12}
      spacing={2}
      sx={{ justifyContent: "flex-start", alignItems: "center" }}>
      {articlesList.map(
        (article, i) =>
          article.statutArticle !== Statut.REFUSE && (
            <Grid
              container
              spacing={2}
              key={article.articleId}
              size={12}
              sx={{ alignItems: "center", "& strong": { fontWeight: 600 } }}>
              <Grid container size={12} spacing={1}>
                <Grid size={{ xs: 12, md: 6, lg: 9, xl: 12 }}>
                  <Typography>
                    <strong>{article.articleLabel}</strong>
                  </Typography>
                </Grid>
                <Grid size={{ xs: 2, sm: 3, md: 1 }}>
                  <Typography>
                    Qté : <strong>{article.quantite}</strong>
                  </Typography>
                </Grid>
                <Grid size={{ xs: 2, sm: 3, md: 2 }}>
                  <Typography>
                    Taille :{" "}
                    <strong>
                      {article.taille === "Taille unique" ? "unique" : article.taille}
                    </strong>
                  </Typography>
                </Grid>
                <Grid size={{ xs: "grow", sm: 6, md: 3, lg: "auto" }}>
                  <TextField
                    size="small"
                    fullWidth
                    label="N° Bon de commande"
                    placeholder="4500037812MAG"
                    value={article.numeroBonDeCommande ?? ""}
                    onChange={(e) => {
                      updateNumeroBonDeCommande(i, e.target.value);
                    }}
                    required={article.statutArticle === Statut.COMMANDE}
                    disabled={article.statutArticle !== Statut.COMMANDE}
                  />
                </Grid>
                <Grid
                  container
                  size={{ xs: 12, lg: "grow" }}
                  sx={{ justifyContent: { xs: "center", lg: "flex-end" } }}>
                  <StatutButtonGroup
                    onChangeStatut={(newStatut?: Statut) => {
                      if (newStatut != null) {
                        updateStatut(i, newStatut);
                      }
                    }}
                    value={article.statutArticle}
                    statutOptions={magasinierArticleStatutOptions}
                  />
                </Grid>
              </Grid>
              <ArticleHistoriqueStepper statutHistories={article.statutHistories} />
              <Grid size={12}>
                <Divider />
              </Grid>
            </Grid>
          )
      )}
    </Grid>
  );
}

export default ArticleListStore;
